import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base";
import { getESGReqHeader } from "./tool-service";

export const getAllCahceData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("b2010501"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("b2010501")}`, method: "post", data: ReqBody });
};

export const clearCahceData = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("b2010502"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("b2010502")}`, method: "post", data: ReqBody });
};
